import { render, staticRenderFns } from "./schedule-list-item.vue?vue&type=template&id=3dfb0c23&scoped=true"
import script from "./schedule-list-item.vue?vue&type=script&lang=js"
export * from "./schedule-list-item.vue?vue&type=script&lang=js"
import style0 from "./schedule-list-item.vue?vue&type=style&index=0&id=3dfb0c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb0c23",
  null
  
)

export default component.exports